import styled from "styled-components";

import { viewports } from "../styles/variables";

export const THUMBNAIL_TRANSITION_DURATION = 300;
export const THUMBNAIL_HEIGHT = 200;

export const Z_INDEX_ON_TOP = 1000;
export const Z_INDEX_NOT_ON_TOP = 100;

interface SectionThumbnailProps {
  picTranslateY: number;
  onTop: boolean;
}

const SectionThumbnail = styled.div<SectionThumbnailProps>`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: ${THUMBNAIL_HEIGHT}px;
  margin-bottom: 20px;
  z-index: ${({ onTop }) => (onTop ? Z_INDEX_ON_TOP : Z_INDEX_NOT_ON_TOP)};
  transform-origin: center;
  transform: translateY(${props => props.picTranslateY}px) translateZ(0);
  transition: transform ${THUMBNAIL_TRANSITION_DURATION}ms cubic-bezier(0.17, 0.67, 0.23, 0.89);
  color: white;
  user-select: none;
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  &:active {
    transform: translateY(${props => props.picTranslateY}px) scale(0.97) translateZ(0);
    transform: translateY(${props => props.picTranslateY}px) scale(0.97) translateZ(0);
  }
  ${viewports.desktop`
    max-width: 800px;
    margin: 0 auto 20px auto;
  `};
`;

export default SectionThumbnail;

interface SectionThumbnailImageProps {
  background: string;
}

export const SectionThumbnailImage = styled.div<SectionThumbnailImageProps>`
  position: absolute;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-position: center;
  background-size: cover;
  background-color: lightgrey;
  background-image: linear-gradient(rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), url(${props => props.background});
  transform: translateZ(0);
`;

interface FakeMarginProps {
  marginTranslateX: number;
}

export const FakeMarginLeft = styled.div<FakeMarginProps>`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 20px;
  background: white;
  transform: translateX(${props => -props.marginTranslateX}px) translateZ(0);
  transition: transform ${THUMBNAIL_TRANSITION_DURATION}ms cubic-bezier(0.17, 0.67, 0.23, 0.89);
`;

export const FakeMarginRight = styled.div<FakeMarginProps>`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  width: 20px;
  background: white;
  transform: translateX(${props => props.marginTranslateX}px) translateZ(0);
  transition: transform ${THUMBNAIL_TRANSITION_DURATION}ms cubic-bezier(0.17, 0.67, 0.23, 0.89);
`;



// WEBPACK FOOTER //
// ./src/components/SectionThumbnail.tsx